@if (activeVariant(); as activeVariant) {
  <div class="product-main">
    <app-product-media [product]="activeVariant"></app-product-media>
    <app-product-details
      [variants]="_variants"
      [activeVariant]="activeVariant"
      (activeVariantChange)="onActiveVariantChange($event)"
      (addToCart)="onAddToCart($event)"
    >
    </app-product-details>
  </div>
  <app-product-description [activeVariant]="activeVariant"> </app-product-description>
  <app-product-safety-description
    [productType]="activeVariant.variantSku"
  ></app-product-safety-description>
  <div #trustMate></div>
  <!--  <app-product-description [activeVariant]="activeVariant"> </app-product-description>-->
}
